import { Loader } from "@allwyn/design-system/src/loader/loader";
import { showAlert } from "@allwyn/design-system/src/modal-alert/show-alert";
import { useSessionStorage } from "@allwyn/storage/composables/use-storage";
import { useNgCasino } from "./use-ng-casino";
import { useNgCasinoState } from "./use-ng-casino-state";

const CHECKOUT_TIMEOUT = 20_000;

let depositTimeout = null;
const storageName = "active-game";
let store: ReturnType<typeof useSessionStorage>;
// eslint-disable-next-line
let initialized = false;

interface ActiveGame {
    gameId: number;
    moneyMode: boolean;
}

export const useCasinoCheckoutManager = async () => {
    //this is a circular dependency, we need to import it here to avoid issues on Sazkabet
    const { isNgCasinoModuleLoaded, launchGame } = useNgCasino();
    await ensureManagerInitialized();

    async function ensureManagerInitialized() {
        if (initialized) return;
        initialized = true;

        store = useSessionStorage();
        const activeGame = store.getJson<ActiveGame>(storageName);
        if (activeGame?.gameId) {
            Loader.showNow("Čekáme na připsání peněz na váš účet.");
            depositTimeout = setTimeout(async () => {
                Loader.hide();
                showAlert({ title: "Peníze se nepodařilo připsat v limitu" });
                startGame(activeGame);
            }, CHECKOUT_TIMEOUT);
        }
    }

    function registerCheckoutCallbacks() {
        ng_hs.depositAborted(() => {
            clearTimeout(depositTimeout);
            onDepositStateChange();
        });

        ng_hs.depositSucceeded(() => {
            clearTimeout(depositTimeout);
            onDepositStateChange();
        });

        ng_hs.depositTimeout(() => onDepositStateChange());

        ng_hs.depositPending(() => onDepositStateChange());
    }

    function onDepositStateChange() {
        ng_hs.onStateChange((ngState) => {
            if (ngState === "idle") {
                const activeGame = store.getJson<ActiveGame>(storageName);
                store.removeItem(storageName);
                if (activeGame?.gameId) {
                    clearTimeout(depositTimeout);
                    Loader.hide();
                    startGame(activeGame);
                }
            }
        });
    }

    async function onDepositRedirectionStart() {
        if (!isNgCasinoModuleLoaded) {
            return;
        }

        const { currentGameId, playForMoney } = useNgCasinoState();
        if (!currentGameId.value) {
            return;
        }

        const activeGame: ActiveGame = {
            gameId: currentGameId.value,
            moneyMode: playForMoney.value,
        };
        store.setJson(storageName, activeGame, "essential");
    }

    async function startGame(activeGame: ActiveGame) {
        store.removeItem(storageName);
        launchGame({ gameId: activeGame.gameId, moneyMode: activeGame.moneyMode });
    }

    return {
        registerCheckoutCallbacks,
        onDepositRedirectionStart,
    };
};
